import "./styles.scss";

import { useDashboard } from "context/admin/dashboard";
import { useTasks } from "context/admin/tasks";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import PageLoader from "components/PageLoader";
import { DeadlineTasks } from "./components";
import Notifications from "page_components/shared/dashboard/Notifications";
import TaskSummary from "page_components/shared/dashboard/TaskSummary";
import ScrollTopMobile from "components/ScrollTopMobile";

import useResponsive from "libs/helpers/useResponsive";

const actions = [
  {
    type: "send_notification",
  },
  {
    type: "create_task",
  },
];

const mainClass = "dashboard-admin-content";

const DashboardAdminContent = () => {
  const { init_loading } = useDashboard();
  const { max } = useResponsive();

  const { data } = useTasks();

  return (
    <DashboardContentLayout actions={actions}>
      <div className={mainClass}>
        {init_loading ? (
          <PageLoader />
        ) : (
          <>
            <div className={`${mainClass}__row`}>
              <div className={`${mainClass}__col ${mainClass}__col--summary`}>
                <TaskSummary data={data} />
              </div>
              <div
                className={`${mainClass}__col ${mainClass}__col--notifications`}
              >
                <Notifications />
              </div>
            </div>
            <div className={`${mainClass}__row`}>
              <div className={`${mainClass}__col`}>
                <DeadlineTasks />
              </div>
            </div>
            {max.sm && <ScrollTopMobile />}
          </>
        )}
      </div>
    </DashboardContentLayout>
  );
};

export default DashboardAdminContent;
